<template>
  <div
    :class="[
      ' d-flex flex-column justify-center align-center cursor-pointer font-weight-bold text-center',
      color,
      isCircle ? 'fab rounded-circle' : 'rounded-lg',
      applyDashedBorder ? 'dashed-outline-border' : 'outlined-border',
    ]"
    :style="`width: ${containerWidth}px; height: ${containerHeight}px;z-index: ${this.zIndex}; position: ${this.cssPosition}`"
    v-ripple="{
      center: true,
      class: isCircle ? 'rounded-circle' : 'rounded-lg',
    }"
    @click="$emit('click')"
  >
    <div><v-icon>mdi-image-outline</v-icon></div>

    <div class="grey--text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String, default: "+ Add new image" },
    size: { type: Number, default: 175 },
    isCircle: { type: Boolean, default: false },
    isRectangle: { type: Boolean, default: false },
    applyDashedBorder: { type: Boolean, default: false },
    height: { type: Number, default: 175 },
    width: { type: Number, default: 175 },
    zIndex: { type: Number, default: 1 },
    cssPosition: { type: String, default: "static" },
    color: { type: String, default: "" },
  },
  computed: {
    containerHeight() {
      if (this.isRectangle) return this.height;
      else return this.size;
    },
    containerWidth() {
      if (this.isRectangle) return this.width;
      else return this.size;
    },
  },
};
</script>

<style >
.dashed-outline-border {
  /* border: 3px dashed #e0e0e0 !important; */
  outline: 3px dashed #e0e0e0 !important;
}

.outlined-border {
  border: 1px solid #e0e0e0;
}
</style>